import { useState, useEffect, useRef, useMemo } from 'react'
import _ from 'lodash'
import { Modal } from '@vzmi/shp_shared_compo'
import SortableTable, {
  DragHandler
} from '../../../../../../Common/SortableTable/SortableTable'
import NoData from '../../../../../../Common/NoData/NoData'
import {
  COLUMN,
  GROUP_SKU_KEY,
  FORM_SECTION,
  UPDATE_COLLECT_KEY
} from '../../helper'
import { openPortal } from '../../withTableActions'
import styles from './index.css'

const locale = {
  emptyText: <NoData />
}

const checkToStoreAction = () => false

const SpecSortModal = props => {
  const {
    change,
    tableType,
    title,
    readOnly,
    visible,
    setVisible,
    sortedSpecs = [],
    complimentaries = [],
    groupMapByGroupSku = {}
  } = props
  const [currentSortedSpecs, setCurrentSortedSpecs] = useState([])
  const [defaultSortedSpecs, setDefaultSortedSpecs] = useState([])
  const currentVisible = useRef(false)
  const uniqSortedSpecs = useMemo(() => _.uniqBy(sortedSpecs, 'spec'), [sortedSpecs])

  const columns = [
    {
      key: 'sortableIcon',
      width: 50,
      align: 'center',
      render: (text, record) => {
        const { index } = record
        return (
          <DragHandler
            id={index}
            disabled={readOnly}
          />
        )
      }
    },
    {
      key: 'spec',
      render: (text, record) => {
        const { spec } = record
        return spec
      }
    }
  ]

  const onSpecSortEnd = sortedSpecs => setCurrentSortedSpecs(sortedSpecs)

  const onConfirmedOk = () => {
    // 既有排序的資料列按照 spec 分群
    const complimentariesGroupedBySpec = _.groupBy(complimentaries, complimentary => {
      const groupSku = _.get(complimentary, GROUP_SKU_KEY)
      const isNoAttr = _.isUndefined(groupSku)
      let spec = _.get(complimentary, COLUMN.ATTR_NAME)
      if (!isNoAttr) {
        spec = _.get(groupMapByGroupSku, `${groupSku}.${COLUMN.GROUP_NAME}`, '')
      }
      return spec
    })
    // 拿出新排序出來的 spec 重組既有排序的資料列
    const sortedComplimentaries = _.flow(
      () => _.map(currentSortedSpecs, ({ spec }) => _.get(complimentariesGroupedBySpec, spec, [])),
      groupedComplimentaries => _.concat(...groupedComplimentaries),
      newComplimentaries => _.map(newComplimentaries, (newComplimentary, index) => {
        return {
          ..._.omit(newComplimentary, [UPDATE_COLLECT_KEY]),
          index
        }
      })
    )()
    change(`${FORM_SECTION}.${tableType}`, sortedComplimentaries)
    onCancel()
  }

  const onOk = () => {
    const isFirstSpecChange = !_.isEqual(defaultSortedSpecs[0], currentSortedSpecs[0])
    // 第一筆排序變更時需要跳出視窗提示
    if (isFirstSpecChange) {
      return openPortal({
        content: '更換排序後，贈品代表圖將被替換，你確定要更換商品排序？',
        onOk: onConfirmedOk
      })
    }

    return onConfirmedOk()
  }

  const onCancel = () => setVisible(false)

  useEffect(() => {
    setCurrentSortedSpecs(uniqSortedSpecs)
  }, [uniqSortedSpecs])

  // 打開調整排序視窗時存下預設排序，在確認修改時用來判斷第一筆排序是否變更
  useEffect(() => {
    if (!currentVisible.current && visible) {
      setDefaultSortedSpecs(uniqSortedSpecs)
    }

    currentVisible.current = visible
  }, [uniqSortedSpecs, visible])

  return (
    <Modal
      title={`調整${title}顯示順序`}
      data-role={`${tableType}SpecSortModal`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <SortableTable
        data={uniqSortedSpecs}
        locale={locale}
        columns={columns}
        className={styles.specTable}
        onSortEnd={onSpecSortEnd}
        checkToStoreAction={checkToStoreAction}
      />
    </Modal>
  )
}

export default SpecSortModal
